export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'theme'
const CHANGE_EVENT = 'metrly-theme-change'

function readPreference(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'
  } catch {
    return 'dark'
  }
}

function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  document.documentElement.style.colorScheme = theme
  window.dispatchEvent(new Event(CHANGE_EVENT))
}

function onStorage(event: StorageEvent) {
  if (event.key === STORAGE_KEY || event.key === null) applyTheme(readPreference())
}

/** Apply before React mounts, including public auth pages and standalone consoles. */
export function initializeTheme() {
  applyTheme(readPreference())
  window.addEventListener('storage', onStorage)
}

export function getTheme(): Theme {
  if (typeof document === 'undefined') return 'dark'
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export function subscribeTheme(listener: () => void) {
  window.addEventListener(CHANGE_EVENT, listener)
  return () => window.removeEventListener(CHANGE_EVENT, listener)
}

export function setTheme(value: Theme | ((previous: Theme) => Theme)) {
  const theme = typeof value === 'function' ? value(getTheme()) : value
  applyTheme(theme)
  // Persist deliberate choices only; the default must not become a saved override.
  try { localStorage.setItem(STORAGE_KEY, theme) } catch { /* Storage is optional. */ }
}
